var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIdleCashToolTip(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.125 5.625H6.875V4.375H8.125M8.125 10.625H6.875V6.875H8.125M7.5 1.25C6.67924 1.25 5.86651 1.41166 5.10823 1.72575C4.34994 2.03984 3.66095 2.50022 3.08058 3.08058C1.90848 4.25269 1.25 5.8424 1.25 7.5C1.25 9.1576 1.90848 10.7473 3.08058 11.9194C3.66095 12.4998 4.34994 12.9602 5.10823 13.2742C5.86651 13.5883 6.67924 13.75 7.5 13.75C9.1576 13.75 10.7473 13.0915 11.9194 11.9194C13.0915 10.7473 13.75 9.1576 13.75 7.5C13.75 6.67924 13.5883 5.86651 13.2742 5.10823C12.9602 4.34994 12.4998 3.66095 11.9194 3.08058C11.3391 2.50022 10.6501 2.03984 9.89177 1.72575C9.13349 1.41166 8.32076 1.25 7.5 1.25Z",
    fill: "#0E4979"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIdleCashToolTip);
export default __webpack_public_path__ + "static/media/idleCashToolTip.88fb76c9a19f49a46f4a6f9659f5943b.svg";
export { ForwardRef as ReactComponent };